<template>
	<div id="app">

		<div v-if="meuName=='home'"
			 class="baver">
			<div class='baver-centen'>
				<div class="baver-centen-zerin"></div>
				<div class='baver-centen-one'>
					专业、安全的在线管理与在线作业系统</div>
				<div class='baver-centen-two'>
					MOS让管理与作业兼得</div>
				<div class='baver-centen-three'>
					<Icon type="md-add"
						  class="baver-centen-three-icon" />安徽省工程造价咨询企业信息化管理系统
				</div>
				<div class='baver-centen-four'>
					<Button @click="joinUs"
							class="baver-centen-four-btn">立即开通</Button>
				</div>
			</div>
		</div>
		<div v-if="meuName=='functionalFeatures'"
			 class=" baver-two">
			<div class='baver-centen'>
				<div style="height:40px
        "></div>
				<div class='baver-centen-five'>
					MOS</div>
				<div class='baver-centen-five mb30 '>
					共享智能 <span>管理与作业系统</span></div>
				<div class='baver-centen-six mb30'>
					Management and Operations system
				</div>
				<div class='baver-centen-four'>
					<Button @click="joinUs"
							class="baver-centen-four-btn">马上体验</Button>
				</div>
			</div>
		</div>
		<div v-if="meuName!='functionalFeatures'&&meuName!='home'"
			 class=" baver-three">
			<div class='baver-centen'>
				<div style="height:40px
        "></div>
				<div class='baver-centen-five'>
					MOS</div>
				<div class='baver-centen-five mb30 '>
					共享智能 <span>管理与作业系统</span></div>
				<div class='baver-centen-six mb30'>
					Management and Operations system
				</div>
				<div class='baver-centen-four'>
					<Button @click="joinUs"
							class="baver-centen-four-btn">马上体验</Button>
				</div>
			</div>
		</div>
		<div class="dx-menu">
			<div class="system-name"><span>MOS管理与作业系统</span></div>
			<Menu mode="horizontal"
				  :theme="theme1"
				  active-name="home"
				  @on-select="selectedItem">
				<MenuItem name="contactUs">
				联系我们
				</MenuItem>
				<MenuItem name="AppliedValue">
				应用价值
				</MenuItem>
				<MenuItem name="functionalFeatures">
				功能特点
				</MenuItem>
				<MenuItem name="Generalization">
				概况
				</MenuItem>
				<MenuItem name="home">
				首页
				</MenuItem>
			</Menu>
		</div>
		<router-view />
		<div class="dx-bottom">
			<div class="dx-bottom-one">
				<Row>
					<Col span="12">
					<p class="dx-bottom-one-p">联系我们</p>
					<p class="dx-bottom-one-p dx-bottom-one-twop">公司名称:安徽本末数据科技有限公司</p>
					<p class="dx-bottom-one-p dx-bottom-one-twop">地址: 安徽省合肥市经济技术开发区翡翠路港澳广场A座1704 -05#</p>
					<p class="dx-bottom-one-p dx-bottom-one-twop">电话: 0551- 65860136-6666(业务咨询) 6555(技术支持售后服务)</p>
					</Col>
					<Col span="12"
						 style="text-align:left">
					<img src="./assets/images/codeimg.png"
						 style="width: 150px;	height: auto;	max-width: 100%;	max-height: 100%">
					</Col>
				</Row>
			</div>
			<div class="dx-bottom-two">
				Copyright 2016安徽本末数据科技有限公司版权所有All Rights Reserved
			</div>
		</div>
		<Modal v-model="modal.flag"
			   :title="modal.title"
			   :width="modal.width"
			   class-name="vertical-center-modal modal-no-footer"
			   :mask-closable="false"
			   :footer-hide="true"
			   @on-visible-change="visibleChange">
			<join-us v-if="modal.type == 'join'"
					 @on-success="applySuccess"></join-us>
		</Modal>
	</div>
</template>

<script>
import joinUs from './components/bm-project/joinUs'
export default {
	components: { joinUs },
	name: 'App',
	data() {
		return {
			meuName: 'home',
			theme1: 'light',
			modal: {
				title: '获取体验帐号',
				type: '',
				flag: false,
				closable: false,
				width: 550,
			},
		}
	},
	created() {},
	mounted() {},
	computed: {},
	methods: {
		//切换导航
		selectedItem(val) {
			this.meuName = val
			this.$router.push({
				name: val,
			})
		},
		joinUs() {
			// this.modal.type = 'join'
			// this.modal.flag = true
			window.open(' http://hy.ahzjxh.org.cn/')
		},
		//关闭弹窗
		visibleChange(state) {
			state ? '' : (this.modal.type = '')
		},
		//申请账号成功回调
		applySuccess() {
			this.modal.type = ''
			this.modal.flag = false
		},
	},
}
</script>

<style >
#app {
	width: 100%;
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
	margin: 0 auto;
	position: relative;
}
.baver {
	width: 100%;
	height: 400px;
	background-image: url('./assets/images/bm_banner2.jpg');
	background-size: cover;
	background-position: center center;
}
.baver-two {
	width: 100%;
	height: 400px;
	background-image: url('./assets/images/bm_banner4.jpg');
	background-size: cover;
	background-position: center center;
}
.baver-three {
	width: 100%;
	height: 400px;
	background-image: url('./assets/images/bm_banner5.jpg');
	background-size: cover;
	background-position: center center;
}
.baver-centen {
	width: 900px;
	margin: 0 auto;
}
.baver-centen-zerin {
	height: 100px;
}
.baver-centen-one {
	font-size: 40px;
	color: #fff;
	text-align: left;
	margin-bottom: 10x;
}
.baver-centen-five {
	font-size: 55px;
	color: #fff;
	text-align: center;
	margin-bottom: 10x;
}
.baver-centen-five span {
	margin-left: 40px;
}
.baver-centen-six {
	color: #fff;
	font-size: 20px;
	text-align: center;
}
.baver-centen-two {
	color: #fff;
	font-size: 30px;
	text-align: right;
	margin-bottom: 20px;
}
.baver-centen-three {
	color: #fff;
	font-size: 20px;
	text-align: center;
	background: #0d3bc9;
	border-radius: 50px;
	height: 50px;
	width: 700px;
	line-height: 50px;
	margin-left: 100px;
	margin-bottom: 20px;
}
.baver-centen-three-icon {
	color: #fff;
	font-size: 30px;
	margin-right: 40px;
}
.baver-centen-four-btn {
	margin-bottom: 50px;
}
.login-btn {
	position: absolute;
	top: 320px;
	left: 505px;
	width: 190px;
	height: 36px;
	cursor: pointer;
}
/* .login-btnhome {
	position: absolute;
	top: 256px;
	left: 539px;
	width: 190px;
	height: 36px;
	cursor: pointer;
} */
.dx-menu {
	width: 1200px;
	margin: 0 auto;
	position: relative;
}
.dx-menu .system-name {
	position: absolute;
	left: 10px;
	top: 0;
	height: 50px;
	line-height: 55px;
	z-index: 999;
}
.dx-menu .system-name span {
	color: #5d5a5a;
	font-size: 24px;
}
.title-img {
	width: 100%;
	/* height: 370px; */
}
.dx-bottom {
	height: 260px;
	width: 100%;
	background: #d94042;
}
.dx-bottom-one {
	height: 198px;
	border-bottom: 2px solid #be2829;
	padding: 30px 50px 10px 220px;
}
.dx-bottom-two {
	height: 60px;
	text-align: center;
	color: #fff;
	line-height: 60px;
	font-size: 14px;
}
.dx-bottom-one-p {
	font-size: 18px;
	height: 60px;
	line-height: 60px;
	padding-left: 20px;
	text-align: left;
	color: #fff;
}
.dx-bottom-one-twop {
	font-size: 14px;
	height: 30px;
	line-height: 30px;
}
.mb30 {
	margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue